<form [formGroup]="form" (ngSubmit)="onSubmit()">  
    <button type="submit">Guardar</button>
  </form>